import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../lib/utils';
import { useApplicationSettings } from '../modules/admin/settings/useData';

const ENV_VESSEL_URL = (process.env.REACT_APP_VESSEL_APP_URL || 'http://localhost:3001').replace(/\/$/, '');

/**
 * When a VESSEL account opens the office SPA, redirect them to the vessel portal.
 */
const OfficeVesselRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { colors } = useTheme();
  const { user, isLoading, logout } = useAuth();
  const { applicationSettings } = useApplicationSettings();

  const vesselAppUrl = (
    applicationSettings?.['general.vesselAppUrl'] ||
    ENV_VESSEL_URL
  ).replace(/\/$/, '');

  const loc = user?.typeLocation != null ? String(user.typeLocation).toUpperCase() : '';
  const isVessel = loc === 'VESSEL';

  useEffect(() => {
    if (!isLoading && isVessel && vesselAppUrl) {
      window.location.replace(vesselAppUrl);
    }
  }, [isLoading, isVessel, vesselAppUrl]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className={colors.textSecondary}>Loading...</div>
      </div>
    );
  }

  if (isVessel) {
    return (
      <div className={cn('min-h-screen flex items-center justify-center px-4', colors.background)}>
        <div className={cn('max-w-md w-full rounded-lg border p-6 shadow-sm', colors.surface, colors.border)}>
          <h1 className={cn('text-lg font-semibold mb-2', colors.text)}>Vessel portal</h1>
          <p className={cn('text-sm mb-4', colors.textSecondary)}>
            Vessel accounts use the dedicated vessel application. Redirecting…
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={vesselAppUrl}
              className="inline-flex items-center justify-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
            >
              Open vessel app
            </a>
            <button
              type="button"
              onClick={() => void logout()}
              className={cn(
                'inline-flex items-center justify-center rounded-md border px-4 py-2 text-sm font-medium',
                colors.border,
                colors.text,
              )}
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default OfficeVesselRedirect;
